module.exports = __webpack_public_path__ + "img/west-bromwich-albion.fddee477.png";